import styled from "styled-components";
import { ReactComponent as CreateIc } from "assets/icons/create.svg";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 35px;
  padding: 25px 35px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  min-height: calc(100vh - 80px - calc(35px * 2));

  @media (max-width: 768px) {
    margin: 16px;
    padding: 24px 19px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 17px;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.1);
`;

export const HeaderInfos = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderTitle = styled.h1`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 24px;
  line-height: 37px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 33px;
  }
`;

export const HeaderSubtitle = styled.h2`
  color: ${({ theme }) => theme.colors.gray};
  font-size: 16px;
  line-height: 24px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 22px;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
  width: 100%;
  margin-top: 34px;
`;

export const Hr = styled.hr`
  border-color: ${({ theme }) => theme.colors.black};
  border-style: solid;
  margin: 10px 0px 20px 0px;
`;

export const EditIcon = styled(CreateIc)`
  margin-right: 6px;
  color: ${({ theme }) => theme.colors.gray};
  font-size: 24px;
  height: 24px;
  width: 24px;
  path:nth-child(2) {
    fill: ${({ theme }) => theme.colors.gray};
  }
`;

export const PanelContainer = styled.div`
  width: 100%;
  height: 100%;
  max-width: 571px;
  min-height: 232px;

  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const InfoContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 10px 15px;

  > div {
    display: flex;
    flex-direction: column;
  }
`;

export const Label = styled.span`
  font-size: 16px;
  font-family: "Mangueira Bold";
  margin: 0;
  margin-bottom: 5px;
  color: #7a7a7a;
`;

export const Info = styled.span`
  color: #7a7a7a;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 0;
  word-break: break-all;
`;

export const Action = styled.div`
  svg {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.blue};
  }
`;

export const Badge = styled.div`
  margin-top: 3px;
  padding: 5px 10px;
  border-radius: 3px;
  background: #ffb300;
  color: #fff;
  font-size: 0.7rem;
  display: inline-block;
  @media (max-width: 400px) {
    display: inline-block;
  }
`;

export const ContainerDownload = styled.div`
  display: inline-block;
  margin: 10px 0px;
  text-align: center;
  width: 100%;
  font-size: 14px;
`;

export const Download = styled.a`
  display: inline-block;
  margin-left: 5px;
  text-decoration: underline;
  cursor: pointer;
  color: #808495;
  font-family: "Mangueira Bold";
`;
